import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '../../../../../utils/styles';
import { MenuItem } from '../../../../../context/menuHeader';
import Icons from '../../../../../components/Common/Icons/Icons';
import Link from '../../../../../components/Common/UI/Link';
import { infoTracUser } from '../../../../../contstant';

interface OldStyleMenuProps {
  mainMenuItems: MenuItem[];
  isOldPage?: boolean;
}

function MenuItemLink({ label, path }: MenuItem) {
  const { pathname } = useLocation();
  const newPathname = `/${pathname.split('/').slice(1, 3).join('/')}`;

  return (
    <div className="old-styled-menu-item text-muted-foreground text-xs text-center">
      <NavLink
        to={path}
        className={({ isActive }) =>
          cn(
            'bg-muted min-w-36 block px-2 rounded-t border',
            {
              'bg-[#82b6ed] text-white': isActive || (path.split('/').length > 1 && path === newPathname),
            }, // bg-addition2
          )
        }
        end
      >
        {label}
      </NavLink>
    </div>
  );
}

function OldStyleMenu({ mainMenuItems, isOldPage }: OldStyleMenuProps) {
  return (
    <header
      className={cn(['sticky top-0 z-50 w-full border-b border-border/40', 'bg-white'], {
        relative: isOldPage,
      })}
    >
      <div className="log-out-cont z-5 absolute ml-auto mr-auto left-0 right-0 top-0 text-center text-muted-foreground">
        <div className="mx-auto flex justify-center items-center text-sm">
          <Icons.HomeFilled height={16} width={16} className="mr-1" />
          Hi, {infoTracUser.userFullName} :: {infoTracUser.company} |{' '}
          <a href="/infoTrac/sign-in" className="pl-1 text-blue-600 underline">
            Sign out
          </a>
        </div>
      </div>

      <div className="flex flex-col h-36 gap-1 px-3 py-1">
        <Link to="/infoTrac" className="old-logo flex items-center gap-3 z-10 max-w-max">
          <Icons.InfoImageLogo width={32} height={32} />
          <div>
            <span className="text-xl italic text-addition2 font-semibold">Info</span>
            <span className="text-xl text-black font-extrabold">TRAC</span>
          </div>
        </Link>
        <p className="text-muted-foreground text-lg font-semibold">{infoTracUser.company}</p>

        <div className="flex items-center flex-wrap gap-0.5">
          {mainMenuItems
            .filter(({ hidden }) => !hidden)
            .map(({ label, path }) => (
              <MenuItemLink key={path} path={path} label={label} />
            ))}
        </div>
      </div>
    </header>
  );
}

OldStyleMenu.defaultProps = {
  isOldPage: false,
};

export default OldStyleMenu;
